import { render, staticRenderFns } from "./River.vue?vue&type=template&id=b27c58ae&scoped=true&"
import script from "./River.vue?vue&type=script&lang=js&"
export * from "./River.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27c58ae",
  null
  
)

export default component.exports